import React from 'react';

import Button from '@amzn/meridian/button';
import { createDataCyForJob, type TableDataRow } from 'src/utils/jmrUtils';

interface ModifyBtnProps {
  row: TableDataRow;
  onClickModify: (row: TableDataRow, shiftId?: string) => void;
  canBeModified: boolean;
  hasBeenModified: boolean;
  shiftId?: string;
}

const ModifyBtn = ({ row, hasBeenModified, canBeModified, onClickModify, shiftId }: ModifyBtnProps) => {
  const label = hasBeenModified ? 'Edit' : 'Modify';

  return canBeModified ? (
    <Button
      size="small"
      type="tertiary"
      minWidth="80%"
      data-cy={`${createDataCyForJob(row.name)}-modify`}
      onClick={() => onClickModify(row, shiftId)}
      aria-label={`${label} ${row.name}`}
    >
      {label}
    </Button>
  ) : null;
};

export default ModifyBtn;
